import Summary from './Summary.component';

export default Summary;
